import React from 'react';
import { BarChart3, Columns3, ReceiptText, ShoppingBag, X } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const ACTIONS = [
  { id: 'new-order', label: 'Transaksi Baru', description: 'Buat pesanan pelanggan', path: '/admin/order-create', icon: ShoppingBag, color: 'bg-emerald-50 text-emerald-700' },
  { id: 'kanban', label: 'Kanban', description: 'Pantau alur pesanan', path: '/admin/order-board', icon: Columns3, color: 'bg-sky-50 text-sky-700' },
  { id: 'costs', label: 'Biaya', description: 'Catat biaya operasional', path: '/admin/biaya', icon: ReceiptText, color: 'bg-amber-50 text-amber-700' },
  { id: 'reports', label: 'Laporan', description: 'Lihat laba dan rugi', path: '/admin/reports/profit-loss', icon: BarChart3, color: 'bg-rose-50 text-rose-700', roles: ['owner', 'manager'] },
];

export const QuickAccessActions = ({ userRole, onNavigate, compact = false }) => {
  const navigate = useNavigate();
  const visibleActions = ACTIONS.filter(action => !action.roles || action.roles.includes(userRole));
  const go = path => { (onNavigate || navigate)(path); };
  return <div className={compact ? 'grid grid-cols-2 gap-3' : 'grid grid-cols-1 gap-2 sm:grid-cols-2'}>
    {visibleActions.map(action => {
      const Icon = action.icon;
      return <button key={action.id} onClick={() => go(action.path)} data-testid={`quick-access-${action.id}-button`} className={`group flex items-center gap-3 rounded-xl border border-slate-100 bg-white p-3.5 text-left shadow-sm transition-[transform,box-shadow,background-color] hover:-translate-y-0.5 hover:bg-slate-50 hover:shadow-md ${compact ? 'flex-col items-start gap-2' : ''}`}>
        <span className={`flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-xl ${action.color}`}><Icon size={19} /></span>
        <span><span className="block text-sm font-bold text-slate-800">{action.label}</span><span className="mt-0.5 block text-xs text-slate-400">{action.description}</span></span>
      </button>;
    })}
  </div>;
};

export default function QuickAccessMenu({ open, onClose, userRole }) {
  const navigate = useNavigate();
  if (!open) return null;
  const navigateFromMenu = path => { navigate(path); onClose(); };
  return <div className="fixed inset-0 z-[60] flex items-center justify-center bg-slate-950/35 p-4" onMouseDown={onClose} data-testid="quick-access-modal">
    <section role="dialog" aria-modal="true" aria-labelledby="quick-access-title" onMouseDown={event => event.stopPropagation()} className="w-full max-w-lg animate-fade-in rounded-2xl border border-slate-100 bg-white p-5 shadow-2xl sm:p-6">
      <div className="mb-5 flex items-start justify-between gap-4">
        <div><h2 id="quick-access-title" className="font-manrope text-xl font-bold text-slate-900">Akses Cepat</h2><p className="mt-1 text-sm text-slate-500">Pilih tujuan kerja Anda.</p></div>
        <button onClick={onClose} data-testid="close-quick-access-button" aria-label="Tutup Akses Cepat" className="rounded-xl p-2 text-slate-400 transition-colors hover:bg-slate-100 hover:text-slate-700"><X size={18} /></button>
      </div>
      <QuickAccessActions userRole={userRole} onNavigate={navigateFromMenu} />
    </section>
  </div>;
}